import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';
import { MarkdownContent } from '@backstage/core-components';

const content = `
The Playpilot catalog: every repository in the
[Playpilot GitHub org](https://github.com/Playpilot) and the people and teams
behind them. It refreshes itself every 30 minutes; nothing here is edited by
hand.

- **Catalog**: [browse everything](/catalog). Filter by lifecycle: \`active\`,
  \`stale\` (no push in a year) or \`deprecated\` (archived).
- **Graph**: [see how things connect](/catalog-graph).
- A repository's page shows its README.

Codex is the source of truth for service metadata. Services, infrastructure
and their relations will appear here as Codex starts serving them.
`;

const gettingStartedWidget = HomePageWidgetBlueprint.make({
  name: 'getting-started',
  params: {
    name: 'GettingStarted',
    title: 'Playpilot Backstage',
    description: 'What this portal is and where its data comes from',
    components: async () => ({
      Content: () => <MarkdownContent content={content} />,
    }),
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [gettingStartedWidget],
});
